export default [
    {
        path: '/newsDetail/:id', // 公告
        component: resolve => require(['@/pages/news/newsDetail.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/newsList', // 新闻列表
        component: resolve => require(['@/pages/news/newsList.vue'], resolve),
        meta: { title: "长龙航空" }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/news.js